import DataGrid from 'components/DataGrid';
import Implement from 'components/Implement';
import Page from 'components/Page';

import useData from './hooks/useData';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const AllDataPage: FunctionComponent<Props> = ({ testId = TEST_ID }) => {
    const { data: rows } = useData();

    return (
        <Page testId={testId}>
            <Implement>
                <DataGrid rows={rows} />
            </Implement>
        </Page>
    );
};

export default AllDataPage;
